export default "__VITE_ASSET__DcjsqolC__"